'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const addPaddingNumber = (number) => isNaN(number) ? "" : number == null ? void 0 : number.toString().padStart(2, "0");

exports.addPaddingNumber = addPaddingNumber;
